export default import.meta.ROLLDOWN_FILE_URL__rG3BAfQlc5MQ9WnjLncrw